//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import targetedPackagesQuery from '~/apollo/queries/packages/targeted-package-slug'

export default {
  mixins: [seo],
  // _slug is optional (no sibling index.vue): a bare path would query Strapi
  // with slug undefined (400). 404 instead.
  validate ({ params }) {
    return typeof params.slug === 'string' && params.slug.length > 0
  },
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    targetedPackages: {
      prefetch: true,
      query: targetedPackagesQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      // `data` is undefined when the query errored — guard or the SSR process dies.
      result ({ data, loading, networkStatus }) {
        if (data && data.targetedPackages && data.targetedPackages.length > 0) {
          this.seoTitle = data.targetedPackages[0].name
          this.seoNoindex = !!data.targetedPackages[0].excludeFromSearchResults
        }
        this.fetched = true
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
        this.fetched = true
      }
    }
  }
}

